import { render } from "./ResultsWrapper.vue?vue&type=template&id=56657d5c&scoped=true"
import script from "./ResultsWrapper.vue?vue&type=script&lang=js"
export * from "./ResultsWrapper.vue?vue&type=script&lang=js"

import "./ResultsWrapper.vue?vue&type=style&index=0&id=56657d5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56657d5c"]])

export default __exports__